import { Box, Divider, Flex, Show, Stack } from '@chakra-ui/react'
import type { ReactNode } from 'react'
import { CgChevronDown, CgChevronUp } from 'react-icons/cg'
import { CircleIcon } from '../../../../../../shared/icons/circle'

interface RoadmapListItemProps {
  bulletPointColor?: 'txtDeutschRapPurple' | 'white' | undefined
  children?: ReactNode | undefined
  isFirstEntry?: boolean | undefined
  isLastEntry?: boolean | undefined
}

export function RoadmapListItem({
  bulletPointColor,
  children,
  isFirstEntry = false,
  isLastEntry = false,
}: RoadmapListItemProps) {
  return (
    <Flex align="stretch" gap={[0, 8, 12]}>
      <Show above="sm">
        <Stack
          minW={['30px', '30px', '40px']}
          minH="full"
          align="center"
          position="relative"
          spacing={0}
          gap={0}
        >
          <Stack h="full" justify={isFirstEntry ? 'flex-end' : 'flex-start'} position="absolute">
            <Box h={isFirstEntry || isLastEntry ? '8px' : 'full'}>
              <Divider size="md" borderColor="txtLightGray" orientation="vertical" />
            </Box>
          </Stack>
          <Stack
            w="full"
            h="full"
            align="center"
            justify={isFirstEntry ? 'flex-end' : 'flex-start'}
            position="absolute"
          >
            {isFirstEntry ? <CgChevronUp color="txtWhite" /> : null}
            {!isFirstEntry && !isLastEntry ? (
              <Box mt={4}>
                <CircleIcon
                  color={bulletPointColor}
                  boxSize={6}
                  stroke="txtWhite"
                  strokeWidth={9}
                />
              </Box>
            ) : null}
            {isLastEntry ? <CgChevronDown color="txtWhite" /> : null}
          </Stack>
        </Stack>
      </Show>
      <Stack w="full" color="white" py={6}>
        {children}
      </Stack>
    </Flex>
  )
}
